export default "__VITE_ASSET__3y1HYi_Y__"